<template>
    <div class="begin-import"
        :style="{
            height
        }">
        <!-- upload table loading -->
        <div v-if="type === 1 && isUploading"
            class="table-uploading"
            >表格上传中...</div>
        <!-- table -->
        <el-table v-loading="type === 0 && isTableLoading"
            ref="elTable"
            :data="getTableData"
            :height="'calc(100% - 98px)'">
            <el-table-column
                type="index"
                label="#"
                width="50"
                :fixed="importDataLength > 0">
            </el-table-column>
            <el-table-column
                prop="primary_group_name"
                label="一级分组"
                min-width="100"
                :fixed="importDataLength > 0">
            </el-table-column>
            <el-table-column
                prop="secondary_group_name"
                label="二级分组"
                min-width="100"
                :fixed="importDataLength > 0">
            </el-table-column>
            <el-table-column
                prop="goods_name"
                label="商品名称"
                min-width="160"
                :fixed="importDataLength > 0">
            </el-table-column>
            <el-table-column
                prop="goods_category"
                label="商品类目"
                min-width="80">
            </el-table-column>
            <el-table-column
                prop="purchase_price"
                label="进价"
                min-width="100">
                <template v-slot="{ row }">
                    <template v-if="row.purchase_price && row.unit_name">
                        <span>{{ `${row.purchase_price}元/${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                prop="first_tier_price"
                label="零售价"
                min-width="100">
                <template v-slot="{ row }">
                    <template v-if="row.first_tier_price && row.unit_name">
                        <span>{{ `${row.first_tier_price}元/${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                prop="second_tier_price"
                label="二级阶梯价"
                min-width="130">
                <template v-slot="{ row }">
                    <template v-if="row.second_tier_price && row.unit_name">
                        <span>{{ `${row.second_tier_price.split('、')[0]}${row.unit_name}` }}, </span>
                        <span>{{ `${row.second_tier_price.split('、')[1]}元/${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                prop="third_tier_price"
                label="三级阶梯价"
                min-width="130">
                <template v-slot="{ row }">
                    <template v-if="row.third_tier_price && row.unit_name">
                        <span>{{ `${row.third_tier_price.split('、')[0]}${row.unit_name}` }}, </span>
                        <span>{{ `${row.third_tier_price.split('、')[1]}元/${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                prop="member_price"
                label="会员价"
                min-width="100">
                <template v-slot="{ row }">
                    <template v-if="row.member_price && row.unit_name">
                        <span>{{ `${row.member_price}元/${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                prop="unit_name"
                label="销售单位">
            </el-table-column>
            <el-table-column
                prop="stock"
                label="商品库存"
                min-width="80">
                <template v-slot="{ row }">
                    <template v-if="row.stock && row.unit_name">
                        <span>{{ `${row.stock}${row.unit_name}` }}</span>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                prop="goods_code"
                label="商品编码"
                min-width="130">
            </el-table-column>
            <el-table-column
                prop="goods_barcode"
                label="商品条码"
                min-width="130">
            </el-table-column>
            <el-table-column width="20" />
            <!-- slot -->
            <template slot="empty">
                <p v-if="type === 0">暂无数据</p>
                <div v-else-if="type === 1 && !isUploading" class="table-upload">
                    <qiniu-upload :useDefault="false"
                        :accept="'.xlsx'"
                        :fileNameSuffix="'xlsx'"
                        :beforeUpload="beforeUpload"
                        :onUploadSuccess="uploadSuccess"
                        :onUploadError="uploadError">
                        <label class="align-c" for="file">
                            <i class="el-icon-plus fs-16 mb-2" />
                            <p class="lh-20">点击上传表格</p>
                        </label>
                    </qiniu-upload>
                </div>
                <div v-else />
            </template>
            <!-- append -->
            <template v-if="type === 0">
                <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                    <span class="loading-step-animation">正在加载...</span>
                </p>
                <p v-if="(!isHasMore) && getTableData.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
            </template>
        </el-table>
        <div class="btn-wrapper mt-20 fs-14">
            <!-- 重新上传 错误数据下载 -->
            <div v-if="type === 1" class="upload-download fx-v-center">
                <qiniu-upload v-if="getTableData.length > 0"
                    :useDefault="false"
                    :accept="'.xlsx'"
                    :beforeUpload="beforeUpload"
                    :onUploadSuccess="uploadSuccess"
                    :onUploadError="uploadError">
                    <label class="href" for="file">重新上传</label>
                </qiniu-upload>
                <span v-if="$store.state.shop.isBadGoodsNum > 0" :class="['href', 'fx-v-center', 'ml-20', { 'red-dot': !isHasExport }]" @click="exportLastExcel"><img src="../images/table_download_icon.svg" alt="">失败数据下载</span>
            </div>
            <!-- button -->
            <el-button class="import-btn color-fff"
                type="primary"
                size="medium"
                :disabled="$store.state.shop.isImportingGoodsData || importDataLength === 0 || isUploading"
                @click="startImport">
                <p>{{ $store.state.shop.isImportingGoodsData ? '导入中' : '开始导入' }}</p>
                <p>共{{ importDataLength }}条数据</p>
            </el-button>
            <p v-if="$store.state.shop.isImportingGoodsData" class="fs-14 lh-20 mt-8 align-c color-999">温馨提示：导入过程您可以放心离开此页面，将为您保持后台会员导入进程</p>
        </div>
    </div>
</template>

<script lang="tsx">
import axios from 'axios'
import store from '@/store/index'
import { createComponent, ref, computed, watch, onBeforeMount, onMounted } from '@vue/composition-api'
import QiniuUpload from '@/components/qiniu_upload/qiniu_upload.vue'
import { openMessage, openWarning, useScrollLoad } from '../../../../utils/system'
import xlsxUtil from 'xlsx/dist/xlsx.core.min.js'
import clone from 'lodash/cloneDeep'
import $fetch from '../../../../api'
import { qiniuImageURLPrefix } from '../../../../assets/ts/qiniu'
import mainConfig from '@/api/server_config/main'

export default createComponent({
    props: {
        type: {
            type: Number,
            default: 0
        },
        height: {
            type: String,
            default: 'calc(100vh - 390px)'
        }
    },

    setup: (props, ctx) => {
        const isTableLoading = ref(false)
        const isUploading = ref(false)
        const isHasExport = ref(false)
        const goodsCount = ref(0)
        // 表格导入的数据
        const tableImportData = ref<any[]>([])
        const {
            page: oPage,
            isHasMore,
            isLoading: isScrollLoading,
            bindListener,
            initScrollLoad,
            initScrollState
        } = useScrollLoad({
            isUseLimit: true,
            dataKey: 'goods_infos'
        })

        const tableKeysMap = {
            '一级分组': 'primary_group_name',
            '二级分组': 'secondary_group_name',
            '商品名称': 'goods_name',
            '商品类目': 'goods_category',
            '进价': 'purchase_price',
            '零售价': 'first_tier_price',
            '二级阶梯价': 'second_tier_price',
            '三级阶梯价': 'third_tier_price',
            '会员价': 'member_price',
            '销售单位': 'unit_name',
            '商品库存': 'stock',
            '商品编码': 'goods_code',
            '商品条码': 'goods_barcode'
        }
        const tableKeys = Object.keys(tableKeysMap)

        const oTableKeysMap = exchangeKeyValue(tableKeysMap)
        let tableSrc = ''
        let badSheet: any = null
        let importTableBadData:any[] = []

        const importDataLength = computed(() => {
            return goodsCount.value || tableImportData.value.length
        })

        const getTableData = computed(() => {
            return tableImportData.value
        })

        async function startImport() {
            ctx.root.$store.commit('shop/setIsImportingGoodsData', true)
            ctx.root.$store.commit('shop/setBadGoodsNum', 0)
            ctx.emit('is-importing')
            try {
                await importTableData()
                initState()
            } catch (e) {
                importError(e)
            }
        }

        async function importTableData() {
            try {
                await ctx.root.$store.dispatch('shop/checkImportgoodssheet', tableSrc)
                await ctx.root.$store.dispatch('shop/checkImportGoodsData')
                if (ctx.root.$store.state.shop.isBadGoodsNum > 0) {
                    await openWarning({
                        title: '系统提示',
                        type: 'primary',
                        render() {
                            return (
                                <div class="align-c">
                                    <h2 class="fs-16 fw-600 lh-20 color-333">{ ctx.root.$store.state.shop.isBadGoodsNum }条数据未导入成功</h2>
                                    <p class="fs-12 color-999 lh-16 mt-4">可下载修正</p>
                                </div>
                            )
                        },
                        confirmBtnText: '下载失败数据',
                        cancelBtnText: '取消'
                    }).then(() => {
                        exportLastExcel()
                    }).catch(() => {
                        isHasExport.value = false
                    })
                }
                ctx.emit('import-success')
            } catch (e) {
            }
        }

        async function parseTableData(sheetJson: any[]) {
            const result = changeSheetJsonKey(sheetJson, tableKeysMap)

            return result
        }

        async function beforeUpload(file) {
            isUploading.value = true
            await fileChange(file)
        }

        function exchangeKeyValue (obj) {
            let data = {}
            Object.keys(obj).forEach(key => {
                data[obj[key]] = key
            })
            return data
        }

        function initState() {
            isTableLoading.value = false
            isUploading.value = false
            isHasExport.value = false
            goodsCount.value = 0
            tableImportData.value = []
            tableSrc = ''
            importTableBadData = []
            initScrollState()
        }

        function changeSheetJsonKey(sheetJson: any[], jsonMap: { [prop: string]: string }) {
            const keys = Object.keys(jsonMap)
            function findKeys(k: string) {
                const targetKey = keys.find(key => k.includes(key))
                return {
                    isInkey: targetKey != null,
                    key: targetKey != null ? jsonMap[targetKey] : null
                }
            }
            return sheetJson.map(item => {
                const obj: { [prop: string]: any } = {}
                Object.entries(item).forEach(([k, v]) => {
                    const {
                        isInkey,
                        key
                    } = findKeys(k)
                    if (isInkey) {
                        obj[key as string] = v
                    } else {
                        obj[k] = v
                    }
                })
                return obj
            })
        }

        function exportLastExcel() {
            isHasExport.value = true
            exportExcel()
        }

        function exportExcel() {
            axios.post(mainConfig.url + '/api/goods/migration/invalidgoodsexport', {}, {
                headers: {
                    "Authentication": (store.state as any).shop.token,
                    "ShopAuthentication": localStorage.getItem('shopId'),
                    'LS-Source': 'Web',
                },
                'responseType': 'blob'
            }).then(res => {
                let blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=utf-8'})
                let disposition = res.headers['content-disposition']
                let saveName = disposition && disposition.split(';')[1].split('=')[1].split('.')[0] || '失败的商品数据表格'
                beginDownload(blob, saveName)
            }).catch(e => {
            })
        }

        function beginDownload(url, saveName) {
            if(typeof url == 'object' && url instanceof Blob) {
                url = URL.createObjectURL(url) // 创建blob地址
            }
            const aLink = document.createElement('a')
            aLink.href = url
            aLink.download = saveName + '.xlsx' || '表格.xlsx'
            let event
            if(window.MouseEvent) {
                event = new MouseEvent('click')
            } else {
                event = document.createEvent('MouseEvents');
                event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            }
            aLink.dispatchEvent(event);
        }

        function fileChange(file) {
            return new Promise((resolve, reject) => {
                function fail() {
                    isUploading.value = false
                    reject()
                }

                readWorkbookFromLocalFile(file, async (workbook) => {
                    const sheetJson = xlsxUtil.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]])
                    if (sheetJson.length > 0) {
                        tableImportData.value = await parseTableData(sheetJson)
                        console.log('tableImportData :>> ', tableImportData.value)
                    } else {
                        openMessage('error', '表格数据不能为空')
                        fail()
                    }
                    return tableImportData.value.length === 0 ? fail() : resolve()
                })
            })
        }

        // 读取本地excel文件
        function readWorkbookFromLocalFile(file, callback) {
            const reader = new FileReader()
            reader.onload = function(e: any) {
                const data = e.target.result
                const workbook = xlsxUtil.read(data, { type: 'binary' })
                if(callback) {
                    callback(workbook)
                }
            }
            reader.readAsBinaryString(file)
        }

        function uploadSuccess({ key }) {
            tableSrc = qiniuImageURLPrefix + key
            isUploading.value = false
        }

        function uploadError() {
            isUploading.value = false
            tableImportData.value = []
        }

        function importError(e) {
            ctx.root.$store.commit('shop/setIsImportingGoodsData', false)
            ctx.emit('import-error')
            openMessage('error', e.message || '导入失败')
        }

        return {
            isTableLoading,
            isHasMore,
            isScrollLoading,
            isUploading,
            isHasExport,
            importDataLength,
            // computed
            getTableData,
            startImport,
            fileChange,
            exportLastExcel,
            // methods
            beforeUpload,
            uploadSuccess,
            uploadError
        }
    },

    components: {
        QiniuUpload
    }
})
</script>

<style lang="scss" scoped>
.begin-import {
    position: relative;
    text-align: center;

    .table-uploading {
        position: absolute;
        left: 0;
        top: 44px;
        right: 0;
        bottom: 98px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid rgba(151, 151, 151);
        background-color: rgba(0, 0, 0, .5);
        color: #fff;
        font-size: 14px;
        z-index: 1;
    }

    .table-upload {
        width: 100px;
        height: 50px;
        margin: 0 auto;
        font-size: 14px;

        label {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100px;
            height: 50px;
            border: 1px dashed #ccc;
            border-radius: 4px;
            color: #333;
            line-height: 1;
            cursor: pointer;

            &:hover {
                border-color: #009688;
                color: #009688;

                i {
                    color: #009688;
                }
            }

            &:active {
                background-color: #e6f5f3;
            }

            i {
                color: #666;
                font-weight: bold;
            }
        }
    }

    input#upload {
        display: none;
    }

    .import-btn {
        width: 200px;
        height: 50px;
        padding: 0;

        > span {
            p {
                &:nth-child(1) {
                    line-height: 20px;
                }

                &:nth-child(2) {
                    line-height: 17px;
                    font-size: 12px;
                }
            }
        }
    }

    .btn-wrapper {
        position: relative;

        .upload-download {
            position: absolute;
            top: 0;
            right: 0;

            label,
            span {
                display: inline-flex;

                &.href img {
                    width: 18px;
                }
            }
        }
    }
}
</style>
